
















import SettingsNav from '@/contexts/frontend/SettingsNav.vue'

export default {
  components: {
    'settings-nav': SettingsNav
  }
}
